<div *ngIf="_orderedMenuRoles"
     class="roles-flow-container row fields-group no-filter faded"
     (resized)="onResized($event)">
    <div *ngIf="_orderedMenuRoles" class=" col">
        <div class="list-title d-flex mb-0 flex-grow-1">
            <span class="d-flex w-100 pr-1 title cursor-pointer align-items-center flex-grow-1">
                <div class="d-flex flx-grow-1 w-100" (click)="showFlow = !showFlow">{{ 'Processing roles' | translate }}</div>
                <div class="dropdown align-self-center dropdown mr-2 mt-md-0 p-0 ml-auto"
                    (onShown)="hideLines()"
                    (onHidden)="showLines()"
                    dropdown placement="left-top">
                    <button class="btn btn-ghost btn-sm" dropdownToggle>
                        <i class="fa-regular fa-ellipsis-vertical"></i>
                        <span *ngIf="hasActiveFilters" class="btn-circle-small btn-circle-icon btn-info mr-3 active btn-icon-indicator" tooltip="{{'Filters applied' | translate }}" placement="left">
                            <i class="far fa-sliders-h"></i>
                        </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-left-outside" *dropdownMenu>
                        <div class="dropdown-item">
                            <span class="service-context-menu-item"
                                (click)="toggleFlowDeterminantDrawer()">
                                <i class="fal fa-filter" [class.text-gray]="!hasActiveFilters" [class.text-primary]="hasActiveFilters"></i>
                                {{ 'Flow filters' | translate }}
                                <span *ngIf="hasActiveFilters" class="badge badge-info badge-sm ml-1">Active</span>
                            </span>
                        </div>
                        <div class="dropdown-item">
                            <span class="service-context-menu-item">
                                <i class="fal fa-text text-gray"></i>
                                {{ 'Name' | translate }}
                                <toggle-buttons [minimal]="true" [value]="useFullName" (changed)="switchDisplayedName($event)" [labelFalse]="'Short'" [labelTrue]="'Full'"></toggle-buttons>
                            </span>
                        </div>
                        <div class="dropdown-item">
                            <a href="#" class="service-context-menu-item cursor-pointer"
                               (click)="openTutorial(); $event.preventDefault();">
                                <i class="far text-gray fa-circle-question"></i>
                                {{ 'Tutorial documentation' | translate }}
                            </a>
                        </div>
                        <!--
                        <div class="dropdown-item">
                            <a
                                href="#"
                                class="service-context-menu-item"
                                (click)="openRCList(); $event.preventDefault();"
                            >
                                <i class="far text-gray fa-memo-pad"></i>
                                {{ 'Release notes' | translate }}
                            </a>
                        </div>
                        <div class="dropdown-item">
                            <span class="btn btn-big-icon btn-icon" (click)="showFlow = !showFlow" tooltip="{{(showFlow ? 'Hide flow' : 'Show flow') | translate}}" placement="left">
                                <i class="fal fa-eye{{!showFlow ? '' : '-slash'}}"></i>
                            </span>
                        </div>
                    -->
                    </div>
                </div>
                <span *ngIf="_orderedMenuRoles && _orderedMenuRoles.length > 0" class="list-header-collapse-toggle" (click)="showFlow = !showFlow">
                    <i class="fa fa-angle-{{!showFlow ? 'down' : 'up'}}"></i>
                </span>
            </span>
        </div>
        
        <div class="mr-4 my-4 pr-4" *ngIf="_orderedMenuRoles && _orderedMenuRoles.length && showFlow">
            <div *ngFor="let roleRow of _rolesRows; let i = index;"
                 class="d-flex align-items-center roles-flow-new"
                 [ngClass]="{'reverse': i % 2 != 0, 'ml-5': (i % 2 == 0) && i > 0}">
                <div *ngFor="let group of roleRow; let j = index;"
                     class="roles-flow-group">
                    <!--
                        <ng-container *ngIf="(group && group.length > 1) && getAncestorsMax((i*rowElementsCount) + j).on === 'top' && getAncestorsMax((i*rowElementsCount) + j).max > 0">
                            <div *ngFor="let fake of getArrayN(getAncestorsMax((i*rowElementsCount) + j).max - group.length)" class="role-flow-item">
                                <div class="fake-item overflow-hide">&nbsp;</div>
                            </div>
                        </ng-container>
                    -->
                    <div class="role-flow-item-wrapper" *ngFor="let item of group;">
                        <a class="nav-link role-flow-item justify-content-start align-items-center {{ item.bot ? 'bot-type-' + item.bot?.botType : '' }}"
                            id="{{item.id}}"
                            [routerLinkActiveOptions]="{ exact: false }"
                            [ngClass]="{'bottom-tooltip' : i % 2 != 0, 'active': urlStartWith(baseUrl + '/' + item.id)}"
                            [routerLinkActive]="['active']"
                            [routerLink]="[baseUrl, item.id]"
                            fragment="role-main-tab"
                            (mouseover)="overItem(item)"
                            (mouseout)="outItem(item)"
                            (click)="showFlow = false">
                        <!--
                        <span *ngIf="isForApplicant(item)" class="line">{{ 'Applicant' | translate }}</span>
                        <span *ngIf="item.startRole && showFirstRoles"
                            tooltip="{{'First role' | translate}}"
                            placement="right" class="firstRole-icon {{j > 0 ? 'notReal' : ''}}">
                            1
                        </span>
                        <span
                                *ngIf="item.type === 'BotRole'"
                                class="flow-bot-role flow-bot-{{getBotRoleType(item)}}"
                                [popover]="botsPopover"
                                container="body"
                                containerClass="flow-popover"
                                placement="right"
                                triggers="mouseenter:mouseleave"
                                [ngClass]="{'haveInstitution': item.roleInstitutions.length}">
                            <span>bot</span>
                            <span *ngIf="getRoleBots(item) > 1 && showBots" class="bot-counter">{{getRoleBots(item)}}</span>
                            <ng-template #botsPopover>
                                <div class="flow-popover-content">
                                    <div class="flow-popover-item" *ngFor="let bot of item.botRoleBots?.actions">
                                        <div class="d-flex align-items-center mb-2">
                                            <span class="flow-bot-role flow-bot-{{bot.bots[0]?.botType}} mr-2">
                                                <span>bot</span>
                                            </span>
                                            <span class="font-weight-bold">{{bot.bots[0]?.name}}</span>
                                            <i class="bot-icon fa {{getBotIcon(bot.bots[0]?.botType)}} ml-auto"></i>
                                        </div>
                                        <determinant-query-readonly *ngIf="bot.jsonDeterminants" [jsonDeterminants]="bot.jsonDeterminants"></determinant-query-readonly>
                                        <span class="text-muted" *ngIf="!bot.jsonDeterminants">{{'No determinant' | translate}}</span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                        <span *ngIf="item.registrations?.length && showRegistrations"
                            class="registration-counter"
                            [popover]="registrationsPopover"
                            container="body"
                            containerClass="flow-popover"
                            placement="right"
                            triggers="mouseenter:mouseleave">
                            <i class="far fa-circle-o"></i>
                            <ng-template #registrationsPopover>
                                <div class="flow-popover-content">
                                    <div class="flow-popover-item" *ngFor="let reg of item.registrations">
                                        <div class="d-flex align-items-center">
                                            <span class="font-weight-bold">{{reg.registrationName}}</span>
                                            <i class="far fa-circle-o ml-auto"></i>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                        <span
                                *ngIf="item.bots && item.bots.data && item.bots.data.length"
                                class="flow-bot-role flow-bot-data-action"
                                tooltip="{{'Data bots' | translate}}"
                                placement="top"><span>A</span></span>
                        <span
                                *ngIf="item.bots && item.bots.files && item.bots.files.length"
                                class="flow-bot-role flow-bot-file-action"
                                tooltip="{{'Document bots' | translate}}"
                                placement="top"><span>A</span></span>
                        <span
                                (mouseover)="overItem(item)"
                                (mouseout)="outItem(item)"
                                class="item overflow-hide"
                                id="{{item.id}}">
                            {{displayedName(item)}}
                        </span>
                        -->
                        <span *ngIf="item.startRole && showFirstRoles" tooltip="{{'First role' | translate}}" placement="right" class="role-flow-item-start d-flex align-items-center justify-content-center {{j > 0 ? 'notReal' : ''}}">
                            1
                        </span>
                        <span *ngIf="isForApplicant(item)" tooltip="{{'Applicant' | translate}}" placement="right" class="role-flow-item-applicant d-flex align-items-center justify-content-center">A</span>
                        <span
                                *ngIf="item.type === 'BotRole'"
                                class="flow-bot-role flow-bot-{{getBotRoleType(item)}}"
                                [popover]="botsPopover"
                                container="body"
                                containerClass="flow-popover"
                                placement="right"
                                triggers="mouseenter:mouseleave">
                            <ng-container  *ngIf="getRoleBots(item) < 2 && showBots">B</ng-container>
                            <!--<span *ngIf="getRoleBots(item) > 1 && showBots" class="bot-counter">{{getRoleBots(item)}}</span>-->
                            <ng-container  *ngIf="getRoleBots(item) > 1 && showBots">{{getRoleBots(item)}}</ng-container>
                            <ng-template #botsPopover>
                                <div class="flow-popover-content">
                                    <div class="flow-popover-item my-1" *ngFor="let bot of item.botRoleBots?.actions">
                                        <div class="d-flex align-items-start">
                                            <i class="mt-1 far {{getBotIcon(bot.bots[0]?.botType)}} mr-2"></i>
                                            <span>
                                                <b>{{bot.bots[0]?.name}}</b>
                                                <query-builder
                                                    [jsonString]="bot.jsonDeterminants"
                                                    [easyToRead]="true"
                                                    [noneSelectedText]="'No determinant'"
                                                    [determinantMapById]="determinantMapById"
                                                    [readOnly]="true"></query-builder>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                        <span class="role-flow-item-name overflow-hide align-self-start mr-auto font-weight-bold">
                            {{displayedName(item)}}
                        </span>
                        <span class="d-inline-flex flex-row align-items-center">
                            <span *ngIf="item.registrations?.length && showRegistrations"
                                class="btn-circle-icon btn-circle-small btn-transparent"
                                [popover]="registrationsPopover"
                                container="body"
                                containerClass="flow-popover"
                                placement="right"
                                triggers="mouseenter:mouseleave">
                                <i class="far fa-circle-o"></i>
                                <ng-template #registrationsPopover>
                                    <div class="flow-popover-content">
                                        <div class="flow-popover-item"><b>{{'Registrations' | translate}}</b></div>
                                        <div class="flow-popover-item" *ngFor="let reg of item.registrations;">
                                            <div class="d-flex align-items-center">
                                                {{reg.registrationName}}
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </span>
                        </span>
                        <det-popover class="d-flex align-items-center" *ngIf="hasDeterminants(item.jsonDeterminants) && showDeterminants"
                            [extraClasses]="'active'"
                            [regularSpaces]="false"
                            [determinant]="item.jsonDeterminants"
                            [determinantMapById]="determinantMapById"></det-popover>
                        <a *ngIf="urlStartWith(baseUrl + '/' + item.id)"
                            class="btn-circle-icon btn-circle-small btn-secondary"
                            routerLink="{{baseUrl}}">
                            <i class="fas fa-times"></i>
                        </a>
                    </a>
                    <span *ngIf="item.roleInstitutions?.length > 0 && showInstitutions"
                        class="role-flow-item-institution-chip"
                        [popover]="institutionsPopover"
                        container="body"
                        containerClass="flow-popover"
                        placement="bottom"
                        triggers="mouseenter:mouseleave">
                        <i class="far fa-building-columns"></i>
                        {{getRoleInstitution(item)}}
                        <ng-template #institutionsPopover>
                            <div class="flow-popover-content">
                                <div class="flow-popover-item"><b>{{'Institutions' | translate}}</b></div>
                                <div [innerHtml]="getRoleInstitutionName(item).first" class="w-100"></div>
                                <div *ngIf="getRoleInstitutionName(item).lines" class="w-100">
                                    <div [innerHtml]="getRoleInstitutionName(item).lines"></div>
                                </div>
                            </div>
                        </ng-template>
                    </span>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>

<drawer *ngIf="_orderedMenuRoles" [title]="'Roles flow filters'" [showHeaderButtons]="false" [isClosed]="!showDeterminantsFilters" (closeEvent)="closeSection()">
    <div class="drawer-content drawer-direct-content">
            <role-flow-determinant *ngIf="determinantMapById"
                [roles]="_orderedMenuRoles"
                [determinantMapById]="determinantMapById"
                (determinantSelectionChanged)="onDeterminantSelectionChanged($event)"
                (showDeterminantsFilter)="hasDeterminantsFilter = $event">
            </role-flow-determinant>
            <role-flow-registration *ngIf="serviceRegistrations && serviceRegistrations.length"
                [roles]="_orderedMenuRoles"
                [registrations]="serviceRegistrations"
                [selectedRoleId]="selectedRoleId"
                (registrationSelectionChanged)="onRegistrationSelectionChanged($event)"
                (showRegistrationsFilter)="hasRegistrationsFilter = $event">
            </role-flow-registration>
            <label class="input-label mt-4">{{'Show roles details' | translate}}</label>
            <div class="table-items">
                <div class="item">
                    <div class="row cursor-row" (click)="switchDetails(!showDetails)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showDetails ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show details' | translate}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="row cursor-row" (click)="switchBots(!showBots)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showBots ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show bots' | translate}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="row cursor-row" (click)="switchInstitutions(!showInstitutions)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showInstitutions ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show institutions' | translate}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="row cursor-row" (click)="switchRegistrations(!showRegistrations)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showRegistrations ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show registrations' | translate}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="row cursor-row" (click)="switchDeterminants(!showDeterminants)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showDeterminants ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show determinants' | translate}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="row cursor-row" (click)="switchFirstRoles(!showFirstRoles)">
                        <div class="col-auto align-items-center justify-content-start">
                            <span class="{{showFirstRoles ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">{{'Show first roles' | translate}}</div>
                    </div>
                </div>
            </div>
    </div>
</drawer>
